<script setup lang="ts">
import BotElement from "../../assets/footer/element.svg";
import { breakpointsSematic, useBreakpoints } from "@vueuse/core";
import { useRouter } from "vue-router";
import { useOwner } from "../../stores/website/owner";
import GTC from "../../../public/pdf/CGV_SPEED2MAX_CG_SJ.pdf";

const breakpoints = useBreakpoints(breakpointsSematic);
const isPhone = breakpoints.smaller("tablet");
const { owner } = useOwner();
const router = useRouter();
function goToLegalNotice() {
    void router.push("/legal-notice");
}

function goTo(url: string) {
    window.open(url, "_blank");
}
</script>

<template>
    <VFlex
        :flex-direction="isPhone ? 'column' : 'row'"
        class="has-background-dark p-6 border-footer"
        column-gap="3rem"
        row-gap="2rem"
        justify-content="start">
        <TranslateNamespace path="speed2max.footer">
            <img :src="BotElement" alt="" class="bot-element" />
            <VFlex
                flex-direction="column"
                class="is-size-6 w-footer"
                justify-content="space-between">
                <div class="footer-logo mb-3">
                    <img src="/images/sidebar/T2M_logo_white.svg" alt="Logo" />
                </div>
                <VFlex
                    v-if="owner === undefined || owner === null"
                    flex-direction="column"
                    class="my-2">
                    <a href="tel:+33473141428">04 73 14 14 28</a>
                    <a href="mailto:accueil@speed2max.com">accueil@speed2max.com</a>
                </VFlex>
                <VFlex v-else flex-direction="column" class="my-2">
                    <a :href="`tel:${owner.phoneNumber}`">{{ owner.phoneNumber }}</a>
                    <a :href="`mailto:${owner.mail}`">{{ owner.mail }}</a>
                </VFlex>
                <VFlex flex-direction="column" class="my-2">
                    <p class="mt-4">
                        @2024 Speed2Max -
                        <a
                            role="button"
                            tabindex="0"
                            @click="goToLegalNotice()"
                            @keydown.enter="goToLegalNotice()"
                            ><Translate>.legalNotice</Translate></a
                        >
                    </p>
                </VFlex>
            </VFlex>
            <VFlex flex-direction="column" class="is-flex-grow-0">
                <p class="has-text-white is-uppercase footer-title">
                    <Translate> .title1 </Translate><br />
                    <Translate> .title2 </Translate>
                </p>
                <VDivider class="my-5" color="grey-light"></VDivider>
                <VFlex flex-direction="row" column-gap="3rem" class="mb-6 is-size-6">
                    <VFlex flex-direction="column" row-gap="0.5em">
                        <a href="/kart">
                            <Translate>.kart</Translate>
                        </a>
                        <a href="/event-us">
                            <Translate>.eventFrom</Translate>
                        </a>
                        <a href="/event-your/enterprise">
                            <Translate>.eventTo</Translate>
                        </a>
                    </VFlex>
                    <VFlex flex-direction="column" row-gap="0.5em">
                        <a href="/product-technology/karting">
                            <Translate>.productAndTechnology</Translate>
                        </a>
                        <a href="/discover/history">
                            <Translate>.discover</Translate>
                        </a>
                        <a :href="GTC" target="_blank" rel="noreferrer noopener">
                            <Translate>.gtc</Translate>
                        </a>
                    </VFlex>
                </VFlex>
                <VFlex
                    flex-direction="row"
                    class="has-background-primary py-3 px-5 footer-social"
                    column-gap="1em">
                    <VIconButton
                        icon="/images/footer/facebook.png"
                        color="white"
                        outlined
                        circle
                        @click="goTo('https://www.facebook.com/speed2max')" />
                    <VIconButton
                        icon="/images/footer/instagram.png"
                        color="white"
                        outlined
                        circle
                        @click="goTo('https://www.instagram.com/speed2max/')" />
                    <VIconButton
                        icon="/images/footer/linkedin.png"
                        color="white"
                        outlined
                        circle
                        @click="goTo('https://www.linkedin.com/company/speed2max/')" />
                </VFlex>
            </VFlex>
        </TranslateNamespace>
    </VFlex>
</template>

<style lang="scss" scoped>
@use "sass:color";

a {
    color: white;

    &:hover {
        color: $primary;
    }
}

.footer-logo {
    img {
        max-width: 200px;
    }
}

.footer-title {
    font-family: Mohol;
    font-size: 2.5rem;
}

@media (max-width: 767px) {
    .footer-title {
        font-size: 1.5rem;
    }
}

.border-footer {
    border-top: 5px solid $primary;
}

.w-footer {
    width: 100%;
}

@media (min-width: 767px) {
    .w-footer {
        width: 40%;
    }
}

.footer-social {
    position: absolute;
    bottom: 0;
}

.bot-element {
    position: absolute;
    width: 150px;
    bottom: 0;
    right: 0;
}

.button-icon {
    &:hover {
        background-color: $dark !important;
    }
}
</style>
